import classnames from 'classnames';
import { PropsWithChildren } from 'react';

import styles from './index.module.css';

interface Props {
  noPadding?: boolean;
}

/**
 * Component that can be used with HeroPage to place content in center column and content row.
 *
 * @param children the content.
 * @param noPadding option to remove the default padding provided by the component.
 */
export function HeroContent({ children, noPadding = false }: PropsWithChildren<Props>) {
  return (
    <div
      className={classnames({
        [styles['Content']!]: true,
        [styles['Padding']!]: !noPadding,
      })}
    >
      {children}
    </div>
  );
}
